import type { ReactNode } from "react"
import { SignInCTACard } from "./SignInCTACard"

interface BlurGateProps {
  children: ReactNode
  ctaVariant?: "default" | "followers" | "comments"
  className?: string
}

export function BlurGate({ children, ctaVariant = "default", className = "" }: BlurGateProps) {
  return (
    <div className={`relative ${className}`}>
      <div className="relative overflow-hidden">
        {children}
        <div
          className="absolute bottom-0 left-0 right-0 h-[90%] pointer-events-none"
          style={{
            background:
              "linear-gradient(to bottom, transparent 0%, transparent 30%, rgba(2, 2, 2, 0.6) 60%, rgba(2, 2, 2, 0.95) 100%)",
          }}
        />
      </div>
      <div className=" relative">
        <SignInCTACard variant={ctaVariant} />
      </div>
    </div>
  )
}
